'use strict';

import {
	Group,
	Mesh,
	Shape, ExtrudeGeometry, MeshStandardMaterial, Object3D, Vector3, Box3, Box3Helper, Path,
} from 'three';
import { Floor } from './Floor';
import { mergeGeometries } from 'three/examples/jsm/utils/BufferGeometryUtils';
import { Polygon } from '../../../libs/Polygon';
import { threeJsVariables } from '../../../settings';

export const SCHEMATIC_SCALE = 0.2;
export const FLOOR_HEIGHT = 3;
export const EXTRUDE_SETTINGS = {
	steps: 1,
	curveSegments: 1,
	depth: FLOOR_HEIGHT,
	bevelEnabled: false,
	bevelThickness: 0,
	bevelSize: 0,
	bevelOffset: 0,
	bevelSegments: 1
};

export class SchematicBuildingModel {
	constructor (props,scope) {
		this.props = props;
		this.schematicScope = scope;
		this.type = this.schematicScope.type;
		this.selectionsGroup = new Group();
		this.name = this.props[0].buildingEngineId;
		this.selectionsGroup.name = this.name + '_selectionBoxes';
		
		this.buildingGroup = new Group();
		this.buildingGroup.name = this.name;
		
		const rotation = this.schematicScope.advancedSettings.buildingsRotation[this.name];
		
		if (rotation) {
			this.selectionsGroup.rotation.y = rotation;
			this.buildingGroup.rotation.y = rotation;
		}
		
		this.floors = [];
		
		const floorData = [];

		const floorNum = [...new Set(this.props.map(apt => apt.floorNum))];
		floorNum.sort((a,b) => a - b);
		
		this.floorsCount = floorNum.length;
		
		floorNum.forEach(floorNum => {
			const floorApts = this.props.filter(apt => apt.floorNum === floorNum);
			floorApts.forEach(apt => {
				apt.schematicSize = Math.floor(apt.totalSpace  / this.schematicScope.advancedSettings.quantization) * this.schematicScope.advancedSettings.quantization;
			});
			const data = {
				floor: floorNum,
				type: this.type,
				totalSpace: floorApts.reduce((acc,apt) => acc += apt.schematicSize,0),
				apartments: floorApts
			};
			floorData.push(data);
		});

		this.maxTotalSpace = Math.max(...floorData.map(floor => floor.totalSpace));
		this.maxApartmentsOnTheFloor = Math.max(...floorData.map(floor => floor.apartments.length));
		
		if (this.type === 'auto') {
			if (this.maxApartmentsOnTheFloor <= 4) {
				this.type = 'square';
			} else if (this.maxApartmentsOnTheFloor > 4 && this.maxApartmentsOnTheFloor <= 6) {
				this.type = 'rectangle';
			} else {
				this.type = 'corner';
			}
			floorData.forEach(data => data.type = this.type);
		}
		
		for (let i = 0; i < floorData.length; i++) {
			const data = floorData[i];
			const floor = new Floor(data,this);
			floor.group.position.y = FLOOR_HEIGHT * i;
			this.floors.push(floor);
			this.selectionsGroup.add(floor.group);
		}
		
		this.#createBuildingForm();
		this.#applyAlignReposition();
	}
	
	#applyAlignReposition() {
		// const size = new Vector3();
		// box.getSize(size);
		// const scale = Math.sqrt(this.maxTotalSpace / (size.x * size.z));
		// console.log(scale);
		// this.selectionsGroup.scale.set(scale,1,scale);
		// this.buildingGroup.scale.set(scale,1,scale);
		
		const align = this.schematicScope.advancedSettings.align;
		if (align === 'Center')
			return;
		
		const box = new Box3();
		box.setFromObject(this.selectionsGroup,true);
		const center = new Vector3();
		box.getCenter(center);
		center.y = 0;
		
		const position = new Vector3().sub(center);
		this.selectionsGroup.children.forEach(floor => {
			floor.position.add(position);
		});
		
		this.buildingGroup.children[0].position.copy(position);
	}
	
	#createBuildingForm() {
		const geometries = [];
		
		this.floors.forEach(floor => {
			if (!floor.polygons.out)
				return;
			const polyOutPoints = floor.polygons.out.getPoints();
			const poly = new Polygon(polyOutPoints);
			poly.offset(-3);
			const points = poly.getPoints();
			const shape = new Shape(points);
			shape.holes = [new Path(points)];
			
			const wall = new ExtrudeGeometry(shape,EXTRUDE_SETTINGS);
			wall.rotateX( - Math.PI / 2);
			wall.translate(0,floor.group.position.y + 0.1,0);
			wall.scale(SCHEMATIC_SCALE,1,SCHEMATIC_SCALE);
			
			
			const plugShape = new Shape(points);
			const extrude = JSON.parse(JSON.stringify(EXTRUDE_SETTINGS));
			extrude.depth = 0.1;
			const plugGeometry = new ExtrudeGeometry(plugShape,extrude);
			plugGeometry.rotateX( - Math.PI / 2);
			plugGeometry.translate(0,floor.group.position.y + FLOOR_HEIGHT - 0.2,0);
			plugGeometry.scale(SCHEMATIC_SCALE,1,SCHEMATIC_SCALE);
			
			geometries.push(wall,plugGeometry);
			// geometries.push(wall);
		});
		
		const geometry = mergeGeometries(geometries);
		
		const material = new MeshStandardMaterial({color: '#dadada'});
		const mesh = new Mesh(geometry,material);
		mesh.name = this.name;
		this.buildingGroup.add(mesh);
	}

}
